import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { useCurrentOrg, useIsTester } from 'auth/hooks'
import Loading from 'components/Loading'
import { currentOrgUpdated } from 'auth/actions'
import useOrganization from 'volunteering/organizations/hooks/useOrganization'
import useCreateOrUpdateOrganization from 'volunteering/organizations/hooks/useCreateOrUpdateOrganization'
import OrganizationForm from 'volunteering/organizations/components/OrganizationForm'
import PageHeader from 'App/components/PageHeader'
import { makeStyles } from '@material-ui/styles'
import { useGetOrganizationCreateUpdatePayload } from './useGetOrganizationCreateUpdatePayload'
import { useFeatureEnabled } from 'core/feature/hooks'
import { OrganizationOverview } from 'organization/component/OrganizationOverview'
import { Organization as OrganizationType } from './types'

const useStyles = makeStyles({
  wrapper: {
    background: 'white',
    width: '100%',
    height: '100%',
    padding: '20px 40px',
    overflow: 'auto',
  },
})

interface OrganizationPageProps {
  match: {
    params: {
      id?: String
    }
  }
}

export default function Organization({
  match: {
    params: { id },
  },
}: OrganizationPageProps) {
  const currentOrg = useCurrentOrg()
  const organization = id ? { id: id } : currentOrg
  const isCurrentOrg = !id
  const classes = useStyles()
  const { result, loading, called } = useOrganization(organization.id)
  const [org, setOrg] = useState<OrganizationType | undefined>(undefined)
  const { isTester, loading: testerLoading } = useIsTester()

  const organizationPayload = useGetOrganizationCreateUpdatePayload(result)

  const createOrUpdateOrganization = useCreateOrUpdateOrganization()
  const newOrgPageEnabled = useFeatureEnabled('NewOrgPage')

  const dispatch = useDispatch()
  useEffect(() => {
    setOrg(result)
  }, [result])
  const handleDispatchOrganization = useCallback(
    updatedOrg => {
      setOrg(updatedOrg)
      if (isCurrentOrg) {
        dispatch(currentOrgUpdated(updatedOrg))
      }
    },
    [dispatch, isCurrentOrg],
  )

  const onSubmit = async (values: any) => {
    const updatedOrg = await createOrUpdateOrganization(values, organization.id)
    handleDispatchOrganization(updatedOrg)
    alert('Changes were saved successfully!')
  }

  let subTitle: string, backLink: string | undefined
  if (!id) {
    subTitle = `Edit organizational details`
    backLink = undefined
  } else {
    subTitle = 'Back To Organizations'
    backLink = '/organizations'
  }

  if (!!organization.id && (loading || !called || testerLoading)) {
    return <Loading />
  }

  return (
    <PageHeader title="Organization" subTitle={subTitle} backLink={backLink} noPadding>
      <div className={classes.wrapper}>
        {newOrgPageEnabled ? (
          <OrganizationOverview organization={org} handleDispatchOrganization={handleDispatchOrganization} />
        ) : (
          <OrganizationForm
            justify={'flex-start'}
            onSubmit={onSubmit}
            organization={organizationPayload}
            isTester={isTester}
          />
        )}
      </div>
    </PageHeader>
  )
}
